<div
  class="folder-status__circle {{ size }}"
  [class.clickable]="clickable"
  appFolderStatusCircle
  [type]="type"
  [color]="color"
  [active]="active"
  (click)="clickEditStatusColor()"></div>
